import React, { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import SearchBox from "./SearchBox";
import ResultsList from "./ResultsList";
import ResultsListItem from "./ResultsListItem";
const Box = styled.div `
	font-size: 14px;
	border: 1px solid #ccc;
	padding: 7px;
	vertical-align: top;
	display: inline-block;
	position: relative;

	& ~ & {
		margin-left: 30px;
	}
`;
const SearchTime = styled.div `
	top: 9px;
	right: 30px;
	text-align: right;
	font-style: italic;
	font-size: smaller;
	color: #aaa;
	position: absolute;
`;
const SearchWidget = forwardRef(function SearchWidget({ query, adapter, selectedIndex, setSelectedIndex, onQueryChange, onKeyDown }, ref) {
    const resultsListRef = useRef(null);
    const searchBoxRef = useRef(null);
    const items = adapter.search(query);
    const count = items.length;
    const countDisplay = `${count} result${count > 1 || count === 0 ? "s" : ""}`;
    // don't let the selection go beyond the last item in this SearchWidget,
    // even if the other one has more items
    const maxIndex = Math.min(selectedIndex, count - 1);
    useImperativeHandle(ref, () => ({
        scrollToRow(row) {
            var _a;
            (_a = resultsListRef.current) === null || _a === void 0 ? void 0 : _a.scrollToRow(row);
        },
        scrollByPage(direction) {
            var _a;
            (_a = resultsListRef.current) === null || _a === void 0 ? void 0 : _a.scrollByPage(direction);
        },
        focus() {
            var _a;
            (_a = searchBoxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }));
    return (React.createElement(Box, null,
        React.createElement(SearchBox, { ref: searchBoxRef, query: query, scorerName: adapter.name, onChange: onQueryChange, onKeyDown: onKeyDown }),
        query
            ? React.createElement(SearchTime, null,
                countDisplay,
                " - ",
                adapter.averageTime,
                " ms avg")
            : "",
        React.createElement(ResultsList, { ref: resultsListRef, items: items, itemComponent: ResultsListItem, query: query, maxItems: 10, selectedIndex: maxIndex, setSelectedIndex: setSelectedIndex })));
});
export default SearchWidget;
